import React from 'react';

/**
 * This component is in a separate file so it can be mocked
 */
export var Frame = function Frame(props) {
  return /*#__PURE__*/React.createElement("iframe", {
    title: "i-frame",
    src: "/orders/".concat(props.orderId, "/pay"),
    height: "100%",
    width: "100%",
    style: {
      border: 0
    }
  });
};